import { useTranslation } from "react-i18next";

export default function Stats() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="w-full lg:w-[55%]">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-10">
              {t("stats.title")}
            </h2>
            <div className="grid grid-cols-3 gap-8">
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-primary-500 font-heading">
                  5000+
                </div>
                <p className="text-xs md:text-sm text-foreground-600 mt-2">
                  {t("stats.visits")}
                </p>
              </div>
              <div className="text-center border-l border-r border-background-300/60 px-4">
                <div className="text-4xl md:text-5xl font-bold text-primary-500 font-heading">
                  30+
                </div>
                <p className="text-xs md:text-sm text-foreground-600 mt-2">
                  {t("stats.guides")}
                </p>
              </div>
              <div className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-primary-500 font-heading">
                  100%
                </div>
                <p className="text-xs md:text-sm text-foreground-600 mt-2">
                  {t("stats.free")}
                </p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[45%]">
            <div className="relative h-56 md:h-72 rounded-2xl overflow-hidden bg-gradient-to-br from-primary-100/70 via-accent-100/50 to-secondary-100/60">
              <div className="absolute top-8 left-8 w-20 h-20 rounded-xl bg-primary-200/50"></div>
              <div className="absolute top-12 left-32 w-16 h-16 rounded-full bg-accent-200/50"></div>
              <div className="absolute top-20 right-12 w-24 h-12 rounded-lg bg-primary-100/60"></div>
              <div className="absolute bottom-10 left-16 w-28 h-20 rounded-2xl bg-secondary-200/50"></div>
              <div className="absolute bottom-8 right-16 w-16 h-16 rounded-full bg-accent-100/70"></div>
              <div className="absolute bottom-20 right-32 w-12 h-12 rounded-lg bg-primary-200/40"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}